import styled from 'styled-components'
import IMAGES from '../../images'

export const RegisterPageWrapper = styled.div`
  background-image: url(${IMAGES.FOOTER_LEFT}), url(${IMAGES.FOOTER_RIGHT}),
    linear-gradient(270deg, #00b74f -22.41%, #1d4289 108.33%);
  background-position:
    left bottom,
    right top,
    center;
  background-repeat: no-repeat, no-repeat;
  min-height: 100vh;
`
